import { PdfDocumentType } from '@zinnia/form-engine-sdk';
import { ParticipantRole } from '../participant';

export enum ESignSignerStatus {
  SIGNED = 'SIGNED',
  EMAIL_BOUNCED = 'EMAIL_BOUNCED',
  SIGNER_LOCKED_OUT = 'SIGNER_LOCKED_OUT',
  EXPIRED = 'EXPIRED',
  INTERNAL_SIGNING_EMAIL_SENT = 'INTERNAL_SIGNING_EMAIL_SENT',
}

export enum ESignerMaturityAgeByProvince {
  QC = 18,
  DEFAULT = 16,
}

export type BaseESignSigner = {
  firstName: string;
  lastName: string;
  email: string;
  roles: Omit<ParticipantRole, 'id'>[];
  authMethod: ESignSignerAuthMethod;
  cellphone?: string;
  passcode?: string;
  status?: ESignSignerStatus;
};

export enum ESignSignerAuthMethod {
  cellphone = 'cellphone',
  passcode = 'passcode',
}

export enum EsignSignatureType {
  inPerson = 'inPerson',
  remote = 'remote',
}

export type ESignSigner2FAInfo = BaseESignSigner & {
  partyId?: string;
  documentTypes: PdfDocumentType[];
  tag?: string;
};

export type ESignSigner = BaseESignSigner & {
  id: string;
  ceremonyId: string;
  tag: string;
  lockedOutPreviousStatus?: ESignSignerStatus | null;
};

export type ESignSignerWithSigningUrl = ESignSigner & { signingUrl: string };

export type DatabaseESignSigner = Omit<ESignSigner, 'roles' | 'passcode'> & {
  passcode?: Buffer;
  roles: string[];
};

export enum EnforceUniqueEmailStrategy {
  ALL = 'ALL',
  ADVISORS_ONLY = 'ADVISORS_ONLY',
}

export type ESignSignerActionPayload =
  | { action: 'unlock'; signerId: string; applicationId: string }
  | { action: 'resendEmail'; signerId: string; applicationId: string }
  | { action: 'resendSms'; signerId: string; applicationId: string }
  | {
      action: 'editSigner';
      signerId: string;
      applicationId: string;
      email?: string;
      cellphone?: string;
      passcode?: string;
      authMethod?: ESignSignerAuthMethod;
    };
